export const endpoints = {
  details: '/report/accountDetails',
  events: '/report/accountEvents',
}
